import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDomainConfig } from "../config/domains";

const DynamicMetaTags = () => {
  const { t, i18n } = useTranslation("common");
  const domainConfig = getDomainConfig();

  useEffect(() => {
    // Оновити lang атрибут
    document.documentElement.lang = i18n.language;

    // Оновити title
    const title = t("meta.title");
    document.title = title;

    // Оновити meta description
    const description = t("meta.description");
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", description);

    // Оновити Open Graph title
    const ogTitle = t("meta.ogTitle");
    let metaOgTitle = document.querySelector('meta[property="og:title"]');
    if (!metaOgTitle) {
      metaOgTitle = document.createElement("meta");
      metaOgTitle.setAttribute("property", "og:title");
      document.head.appendChild(metaOgTitle);
    }
    metaOgTitle.setAttribute("content", ogTitle);

    // Оновити Open Graph description
    const ogDescription = t("meta.ogDescription");
    let metaOgDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!metaOgDescription) {
      metaOgDescription = document.createElement("meta");
      metaOgDescription.setAttribute("property", "og:description");
      document.head.appendChild(metaOgDescription);
    }
    metaOgDescription.setAttribute("content", ogDescription);

    // Оновити Open Graph locale
    let metaOgLocale = document.querySelector('meta[property="og:locale"]');
    if (!metaOgLocale) {
      metaOgLocale = document.createElement("meta");
      metaOgLocale.setAttribute("property", "og:locale");
      document.head.appendChild(metaOgLocale);
    }

    // Мапа мов до локалей
    const localeMap: Record<string, string> = {
      de: "de_DE",
      ua: "uk_UA",
      pl: "pl_PL",
      cz: "cs_CZ",
    };
    metaOgLocale.setAttribute("content", localeMap[i18n.language] || "de_DE");
  }, [i18n.language, t, domainConfig.domain]);

  return null;
};

export default DynamicMetaTags;
